import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getAllRoles(__, body) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/rol/get-all/?skip=0&limit=99999`,
          body,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
